"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _base = require("@mui/base");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _user = require("../../store/user");
var _materialEx = require("../../components/material-ex");
var _Style = require("../../style/Style");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = () => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setIsLoading,
    setToastText,
    setToastOpen
  } = (0, _common.useCommonStore)();
  const {
    currentUser,
    users,
    errors,
    fetchUsers,
    deleteUser
  } = (0, _user.useUserStore)();
  (0, _react.useEffect)(() => {
    (async () => {
      setIsLoading(true); // currentUserが存在すればユーザー一覧を取得
      if (!currentUser.companyId) {
        setIsLoading(false);
        return;
      }
      await fetchUsers();
      setIsLoading(false);
    })();
  }, [currentUser]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u30E6\u30FC\u30B6\u30FC\u7BA1\u7406"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
        ...stylex.props(_Style.buttonStyle.primary),
        onClick: () => {
          setLocation('/user/add');
        },
        children: "\u65B0\u3057\u3044\u30E6\u30FC\u30B6\u30FC\u3092\u8FFD\u52A0"
      })]
    }), users.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Table, {
        sx: {
          tableLayout: 'fixed'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableHead, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_materialEx.TableRow, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u30E6\u30FC\u30B6\u30FC\u540D"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u6709\u52B9\u30D5\u30E9\u30B0"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {})]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableBody, {
          children: users.map(user => {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_materialEx.TableRow, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                children: user.name
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                children: user.enableText
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                isCenter: true,
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Stack, {
                  spacing: 2,
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: () => {
                      setLocation('/users/detail/' + user.id);
                    },
                    children: "\u53D7\u8B1B\u72B6\u6CC1"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: () => {
                      setLocation('/user/edit/' + user.id);
                    },
                    children: "\u60C5\u5831\u3092\u7DE8\u96C6"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: () => {
                      setLocation('/user/edit-email/' + user.id);
                    },
                    children: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5909\u66F4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: () => {// setLocation('/users/edit-email/' + user.id)
                    },
                    children: "\u30E6\u30FC\u30B6\u30FC\u306B\u30ED\u30B0\u30A4\u30F3"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: async () => {
                      if (!window.confirm('ユーザー「' + user.name + '」を削除してもよろしいですか？')) return;
                      setIsLoading(true);
                      const deleteResult = await deleteUser(user.id);
                      setIsLoading(false);
                      if (!deleteResult) {
                        setToastText('削除中にエラーが発生しました');
                        setToastOpen(true);
                        return;
                      }
                      setToastText('ユーザー「' + user.name + '」を削除しました');
                      setToastOpen(true);
                    },
                    children: "\u30E6\u30FC\u30B6\u30FC\u3092\u524A\u9664"
                  })]
                })
              })]
            });
          })
        })]
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ...stylex.props(_Style.textStyle.p1b),
      children: errors.list || '該当するユーザーが存在しません'
    })]
  });
};
var _default = exports.default = App;